export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10784.8614ce31.jpg";